import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bagItemDesc } from "@/api/financial/consumptionDetails";
import { template } from "lodash";
import { mapState } from "vuex";
export default {
  name: 'watchBackPackDetails',
  data: function data() {
    return {
      dialogShow: false,
      bagId: '',
      list: [],
      bagList: [],
      dialogLoading: false,
      showItem: [],
      exportAllData: []
    };
  },
  created: function created() {},
  computed: _objectSpread({}, mapState("d2admin", {
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    }
  })),
  methods: {
    init: function init(data) {
      console.log("data===", data);
      this.list = [];
      this.bagList = [];
      this.bagId = "";
      this.showItem = [];
      this.exportAllData = [];

      if (this.rawData.game_mark.indexOf('yjfm') == -1) {
        this.getBagItemDesc(data);
      } else {
        this.bagList = JSON.parse(data);
        console.log("yjData", this.bagList);

        for (var i in this.bagList) {
          var _this$exportAllData;

          this.showItem.push(i);

          (_this$exportAllData = this.exportAllData).push.apply(_this$exportAllData, _toConsumableArray(this.bagList[i]));
        }

        this.list = this.bagList[this.showItem[0]] || [];
        this.bagId = this.showItem[0] || ""; // this.bagList = data ? JSON.parse(data) : []
      }

      this.dialogShow = true;
    },
    getBagItemDesc: function getBagItemDesc(data) {
      var _this = this;

      this.dialogLoading = true;
      var game = data.game,
          platform = data.platform,
          channel = data.channel,
          pkg = data.pkg,
          ad_channel = data.ad_channel,
          ad_placement = data.ad_placement,
          server_id = data.server_id,
          device_id_str = data.device_id_str,
          user_id_str = data.user_id_str,
          role_id = data.role_id,
          time = data.time;
      var paramsData = {
        game_id: this.rawData.game_id,
        params: {
          game: game,
          platform: platform,
          channel: channel,
          pkg: pkg,
          ad_channel: ad_channel,
          ad_placement: ad_placement,
          server_id: server_id,
          device_id_str: device_id_str,
          user_id_str: user_id_str,
          role_id: role_id,
          time: time
        }
      };
      bagItemDesc(paramsData).then(function (res) {
        if (res.status == 200) {
          _this.bagList = res.data;

          for (var i in _this.bagList) {
            var _this$exportAllData2;

            _this.showItem.push(i);

            (_this$exportAllData2 = _this.exportAllData).push.apply(_this$exportAllData2, _toConsumableArray(_this.bagList[i]));
          }

          _this.list = _this.bagList[_this.showItem[0]] || [];
          _this.bagId = _this.showItem[0] || "";
        }
      }).finally(function () {
        _this.dialogLoading = false;
      });
    },
    handleChange: function handleChange(value) {
      this.list = this.bagList[value]; // const selectedItem = this.bagList.find(item => item.desc_name == value);
      // this.list = [selectedItem]
    },
    exportdata: function exportdata() {
      var columns = [{
        label: '物品名称',
        prop: 'desc_name'
      }, {
        label: '物品类型',
        prop: 'desc_kind'
      }, {
        label: '物品id',
        prop: 'desc_item_id'
      }, {
        label: '数量',
        prop: 'desc_num'
      }, {
        label: '品质列表',
        prop: 'quality'
      }];

      if (this.rawData.game_mark.indexOf('yjfm') > -1) {
        columns.push({
          label: '是否装备',
          prop: 'equip'
        });
      }

      var data = this.exportAllData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};